<section *ngIf='show' style="padding: 20px;padding-top: 10px !important;padding-bottom: 0 !important;" class='no0'>
    <div class="col-12">
        <div class="card">
            <div class="card-header no">
                <!-- <h4 style="float: left;">All Attendances : </h4> -->
                <!-- <div style="clear: both;margin-bottom: 5px;"></div> -->
                <div class="m-2" style="text-align: center;">
                    <h2 class="p-2" style="text-align:center;background-color: red;display:inline-block;color: white;"><input (change)='goFilter()' type="date" [(ngModel)]='dateAttend'></h2>
                </div>
                <!-- <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-3 col-12">
                            <input placeholder="Search By Name" [(ngModel)]='searchName' id='plaho' class="p-1 mb-2" type="text" style="width: 100%; height: 25px;border: 1px solid black !important; color: black !important;">
                        </div>
                        <div class="col-lg-3 col-12"> -->
                <!-- <label>From : </label><br> -->
                <!-- <input *ngIf='OrderDate000S0' (change)='goDate()' id="fromDG" placeholder="Search By Code" class="p-1 mb-2 fromDA" type="date" style="width: 94.5%; height: 32px;border: 1px solid black !important; color: black !important;overflow: hidden;">
                            <input style="height: 20px;border: 1px black solid !important; color: black !important;" *ngIf='OrderDate000S' (mouseenter)='OrderDate0010S()' class="text d1 mb-2" type="text" placeholder="From Date" required="">
                        </div>
                        <div class="col-lg-3 col-12"> -->
                <!-- <label>To : </label><br> -->
                <!-- <input *ngIf='OrderDate000SS0' (change)='goDate()' id="toDG" placeholder="Search By Code" class="p-1 mb-2 toDA" type="date" style="width: 94.5%; height: 32px;border: 1px solid black !important; color: black !important;overflow: hidden;">
                            <input style="height: 20px;border: 1px black solid !important; color: black !important;" *ngIf='OrderDate000SS' (mouseenter)='OrderDate0010SS()' class="text d1 mb-2" type="text" placeholder="To Date" required="">
                        </div> -->
                <!-- <div class="col-lg-3 col-12">
                            <select [(ngModel)]='rootSearch' class="form-control mb-2" style="height: 32px !important; width: 100%;border: 1px solid black !important; color: black !important;">
                          <option disabled>Search By Root</option>
                          <option>All</option>
                          <option *ngFor='let x of rootA' [value]="x.id">{{x.name}}</option>
                  </select>
                        </div> -->
                <!-- <div class="col-lg-3 col-12">
                            <select [(ngModel)]='controlSearch' class="form-control mb-2" style="height: 32px !important;width: 100%;border: 1px solid black !important; color: black !important;line-height: 0;">
                          <option disabled>Search By Permission</option>
                          <option>All</option>
                          <option *ngFor='let r of controlA' [value]="r.id">{{r.name}}</option>
                        </select>
                        </div> -->
                <!-- <div class="col-lg-2 col-12">
                            <button (click)='addUser()' style="height: 32px !important; width: 94.5% !important;border: 1px solid black !important;line-height: 0; " type="button" class="btn btn-secondary mb-2">Add Attendance</button>
                        </div>
                        <div class='col-lg-1 col-12'>
                            <button (click)='printert()' class="btn btn-secondary" style="height: 32px !important;border: 1px solid black !important;width: 94.5% !important;line-height: 0;"><i class="fas fa-print"></i></button>
                        </div>
                    </div>
                </div> -->
            </div>





            <div class="card-body" style="padding: 0 !important;">
                <div class="table-responsive dfg" style="overflow: auto;height: 67.2vh;">


                    <div class="container" style="margin: 0 !important;max-width:100% !important;">
                        <table id='calltable' class="responsive-table" style="border-collapse: separate; /* Don't collapse */ border-spacing: 0;">
                            <thead>
                                <tr>
                                    <th style="text-align: center;">No.</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Job</th>
                                    <th scope="col">Attendees</th>
                                    <th scope="col">Leaving</th>
                                    <th scope="col" style="padding: 0 !important;">Leave_with_permission</th>
                                    <th scope="col" style="padding: 0 !important;">Delay_with_permission</th>
                                    <th scope="col" style="padding: 0 !important;">Delay_without_permission</th>
                                    <th scope="col" style="padding: 0 !important;">Absence_with_permission</th>
                                    <th scope="col" class='no'>Absence</th>
                                    <th scope="col" class='no' style="padding: 0 !important;">Absence_of_vacation_balance</th>
                                    <th scope="col">Notes</th>
                                    <th scope="col" class='no' style="padding: 0 !important;z-index: 1;">Refresh</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor='let v of rootA|samedate:dateFrom:dateTo|searchEmployee:searchName; let n = index;'>
                                    <th scope="row" style="text-align: center;">{{n+1}}</th>
                                    <td data-title="Name">{{v.name}}</td>
                                    <td data-title="Job">{{v.typename}}</td>
                                    <td data-title="Attendees"><input (change)='addUser0(v.id)' style="cursor: pointer;box-shadow: none !important;" class="form-control" type="time" value="10:00:00" id="example-time-input1{{v.id}}"></td>
                                    <td data-title="Leaving"><input (change)='addUser0(v.id)' style="cursor: pointer;box-shadow: none !important;" class="form-control" type="time" value="17:00:00" id="example-time-input{{v.id}}"></td>
                                    <td data-title="Leave_with_permission"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios1{{v.id}}" id="exampleRadios1{{v.id}}" value="true"></td>
                                    <td data-title="Delay_with_permission"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios{{v.id}}" id="exampleRadios2{{v.id}}" value="Delay_with_permission"></td>
                                    <td data-title="Delay_without_permission"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios{{v.id}}" id="exampleRadios3{{v.id}}" value="Delay_without_permission"></td>
                                    <td data-title="Absence_with_permission"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios{{v.id}}" id="exampleRadios4{{v.id}}" value="Absence_with_permission"></td>
                                    <td data-title="Absence"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios{{v.id}}" id="exampleRadios5{{v.id}}" value="Absence"></td>
                                    <td data-title="Absence_of_vacation_balance"><input (change)='addUser0(v.id)' style="cursor: pointer;" type="radio" name="exampleRadios{{v.id}}" id="exampleRadios6{{v.id}}" value="Absence_of_vacation_balance"></td>
                                    <td data-title="Notes"><input (change)='addUser0(v.id)' id="Notes{{v.id}}" style="text-align: center;cursor: pointer;box-shadow: none !important;background-color: transparent !important;color: black !important;border: 0 !important;width: 300px !important;height: 100%;"
                                            class="form-control" type="text"></td>
                                    <td data-title="Refresh"><button (click)='delU(v.id)' class='btn btn-danger' style='box-shadow: none !important;'><i class="fas fa-sync-alt rotating"></i></button></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>















        </div>
    </div>
    <!-- <section id="upd">
        <div class="main-w3layouts wrapper" style="z-index: 1;">
            <div class="main-agileinfo">
                <i (click)='close()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
                <div class="agileits-top">
                    <form #data='ngForm' (submit)='addUser0(data.value)' style="direction: ltr !important;">
                        <span id="form00" style="display: block;">
                          <label style="color: white;" class="mt-2">Employee : </label>
                <select [(ngModel)]='root' name="root" class="form-control mt-4 select2 rootSelect" style="height: unset !important;">
                  <option [value]='root' disabled>Employee</option>
                  <option *ngFor='let x of rootA' [value]="x.id">{{x.name}}</option>
          </select>
          <label style="color: white;" class="mt-2">Type : </label>
<select [(ngModel)]='type' name="type" class="form-control" style="height: 32px !important;padding:0 !important">
  <option disabled selected>Type</option>
<option>Presence</option>
<option>Departure</option>
</select>
              <label style="color: white;" class="mt-2">Notes : </label>
              <input style="height: 25px;"  class="text mt-2 d1 UpCha" type="text" name="notes" [(ngModel)]='notes' placeholder="Notes" required="">
                <input style="margin-top: 1rem !important;width: 94.5% !important;float: left; padding: 5px !important;" type="submit" value="Add">
                <div style="clear: both;"></div>
                </span>
                    </form>
                </div>
            </div>
        </div>
    </section> -->

</section>
<section class="loading">
    <div class="spinner">
        <div class="sk-circle">
            <div class="sk-circle1 sk-child"></div>
            <div class="sk-circle2 sk-child"></div>
            <div class="sk-circle3 sk-child"></div>
            <div class="sk-circle4 sk-child"></div>
            <div class="sk-circle5 sk-child"></div>
            <div class="sk-circle6 sk-child"></div>
            <div class="sk-circle7 sk-child"></div>
            <div class="sk-circle8 sk-child"></div>
            <div class="sk-circle9 sk-child"></div>
            <div class="sk-circle10 sk-child"></div>
            <div class="sk-circle11 sk-child"></div>
            <div class="sk-circle12 sk-child"></div>
        </div>
    </div>
</section>
<section id="upd-dd">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closedd()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <span id="form00" style="display: block;">
            <input (click)='ok()' style="margin-top: 1rem !important;width: 94.5% !important;float: left;padding: 5px  !important;" type="submit" value="Are You Sure ?">
            <div style="clear: both;"></div>
            </span>
            </div>
        </div>
    </div>
</section>
<section id="upd-up">
    <div class="main-w3layouts wrapper" style="z-index: 1;">
        <div class="main-agileinfo">
            <i (click)='closeUp()' class="fas fa-times m-4" style="color: white; cursor: pointer;"></i>
            <div class="agileits-top">
                <form #data='ngForm' (submit)='okUp(data.value)' style="direction: ltr !important;">
                    <span id="form00" style="display: block;">
                    <label style="color: white;">Name : </label>
                  <input style="height: 25px;" class="text mt-2 d1" type="text" name="nameU" [(ngModel)]='nameU' placeholder="Name" required="">
                  <label style="color: white;" class="mt-2">E-mail : </label>
                  <input style="height: 25px;"  class="text mt-2 d1" type="text" name="emailU" [(ngModel)]='emailU' placeholder="Email" required="">
                  <label style="color: white;" class="mt-2">Adress : </label>
                  <input style="height: 25px;" class="text mt-2 d1" type="text" name="adressU" [(ngModel)]='adressU' placeholder="Adress" required="">
                  <label style="color: white;" class="mt-2">Branch : </label>
                  <select [(ngModel)]='rootU' name="rootU" class="form-control mt-4 select2 rootSelectU" style="height: unset !important;">
                    <option [value]='rootU' disabled>Branch</option>
                    <option *ngFor='let x of rootA' [value]="x.id">{{x.name}}</option>
            </select>
            <label style="color: white;" class="mt-2">Password : </label>
                  <input style="height: 25px;" class="text mt-2 d1" type="password" name="passwordU" [(ngModel)]='passwordU' placeholder="Password" required="">
                  <label style="color: white;" class="mt-2">Phone : </label>
                  <input style="height: 25px;" class="text mt-2 d1" type="number" name="phoneU" [(ngModel)]='phoneU' placeholder="Phone" required="">
                  <label style="color: white;" class="mt-2">Permission : </label>
  <select [(ngModel)]='controlU' name="controlU" class="form-control mt-4 select2 controlSelectU" style="height: unset !important;">
    <option [value]='controlU' disabled>Permission</option>
    <option *ngFor='let r of controlA' [value]="r.id">{{r.name}}</option>
  </select>
                    <input style="margin-top: 1rem !important;width: 94.5% !important;float: left;padding: 5px  !important;" type="submit" value="Update">
                    <div style="clear: both;"></div>
              </span>
                </form>
            </div>
        </div>
    </div>
</section>
